export const TRANSLATIONS_EN = {
    // COMMON MESSAGES
    UNAUTHORIZED: "Unauthorized",
    ERROR_NO_PERMISSION: "You have no permission",
    NOT_FOUND: "Service not found",
    BAD_REQUEST: "Bad request",
    SERVICE_ERROR: "Service error",
    NETWORK_ERROR: "You have trouble in your internet connection, please verify and try again",
    MAINTENANCE_MODE:
        "Sorry, we are making an improvement to the system, we have incorporated new features and some security updates, give us a few more minutes to finish. Soon you will be able to enjoy them.",
    ERROR_INVALID_VERIFICATION_CODE: "Invalid verification code",
    ERROR_CODE_EXPIRED: "Verification code is expired",
    ERROR_CONTACT_NOT_FOUND: "Contact not found",
    ERROR_GEOLOCATION_UNKNOWN: "An unknown error occurred while trying to access your location.",
    ERROR_GEOLOCATION_PERMISSION_DENIED: "You have denied access to your location. Please allow access to continue.",
    ERROR_GEOLOCATION_POSITION_UNAVAILABLE: "Your location is not available. Please check your device settings.",
    ERROR_GEOLOCATION_TIMEOUT: "The request to access your location timed out. Please try again.",

    fieldRequired: "This field is required",
    fieldInvalid: "Invalid value",

    SUCCESS_DOCUMENT_SHARED: "Document shared successfully",

    CONFIRM_CLOSE_TICKET: "Are you sure you want to close this ticket? This action cannot be undone.",
    CONFIRM_RESOLVE_TICKET: "Are you sure you want to resolve this ticket? This action cannot be undone.",

    // LAYOUT
    footer1: "legale.io is a Despapeliza Llc company. 7345 W Sand Lake RD STE 210, OFC 6837, Orlando, FL, USA",
    footer2: "All rights reserved legale",
    treesSaved: "Trees have been saved using Legale",
    signout: "Sign out",

    // LOGIN
    emailVerify: "Email verify",
    email: "Email",
    submit: "Submit",
    sendCode: "Send code",
    iHaveCode: "I have code",
    verificationCode: "Verification code",
    enterCode: "Enter code",
    verify: "Verify",
    resendCode: "Resend code",

    // EXPLORER
    drive: "Drive",
    myDocuments: "My documents",
    sharedDocuments: "Shared documents",
    searchResult: "Search result",
    paginationDescription: "From {{fromNumber}} to {{toNumber}} (Total {{totalNumber}})",
    loadMore: "Load more",
    user: "User",
    document: "Document",
    description: "Description",
    date: "Date",
    noData: "No data",
    attachedFile: "Attached file",
    file: "File",
    view: "View",
    download: "Download",
    filePreviewNotSupport: "File `{{fileName}}` preview is not supported, please download to view it.",
    share: "Share",
    verification: "Verification",
    workflowInformation: "Workflow information",
    flux: "Flux",
    flux_priority: "By priority",
    flux_simultaneously: "Simultaneously",
    method: "Method",
    rejectedByUser: "Document was rejected by this user",
    startedAt: "Started at",
    openedAt: "Opened at",
    approvedAt: "Approved at",
    signedAt: "Signed at",
    rejectedAt: "Rejected at",
    pausedAt: "Paused at",
    signLink: "Sign link",
    signStatus: "Approve / Sign Status",
    signMethod: "Sign Method",
    signFlowStatus0: "NOT SIGNED",
    signFlowStatus1: "IN PROGRESS",
    signFlowStatus2: "SIGNED",
    signFlowStatus3: "REJECTED",
    signFlowStatus4: "PAUSED",
    signFlowStatus5: "IN PROGRESS",
    signFlowStatus100: "APPROVED",
    copied: "Copied",
    signing: "Signing",
    productName_document: "Document",
    productName_subscription: "Subscription",
    productName_no_sms: "Remote",
    productName_certification: "Cloud certificate",
    productName_sms: "Remote SMS",
    productName_fea: "Remote advanced signature",
    productName_bulk_sign: "Bulk sign",
    productName_video_validation: "Video verification",
    productName_selfie_validation: "Selfie verification",
    productName_id_validation: "Attaching ID",
    productName_geolocation: "Geolocation",
    productName_secondary_user: "Users",
    productName_storage: "Storage",
    productName_approve: "Approve by email",
    productName_approve_legale: "Approve by Legale user",
    productName_approve_api: "Approve",
    productName_email_pin: "Email PIN",
    productName_fiema_sobre: "Group sign",
    productName_tablet_device: "Device Legale mobile",
    productName_tablet_sign: "Signature Legale mobile",
    productName_signbox: "Signbox",
    productName_local_certificate: "Local certificate",
    productName_stamp: "Stamp",
    productName_no_certification: "Define by signer",
    productName_signing_portal: "Signing portal",
    productName_send_email: "Send email",
    sign: "Sign",
    signStatusNotSigned: "Not signed",
    signStatusSigned: "Signed",
    signStatusRejected: "Rejected",
    signStatusReadyToSign: "Ready to sign",
    signStatusWaitingForReview: "Waiting for review",
    inProcess: "In process",
    finished: "Finished",
    failed: "Failed",
    stopped: "Stopped",
    search: "Search",
    startDate: "Start date",
    endDate: "End date",
    all: "All",
    clear: "Clear",
    shareDocument: "Share document",
    emails: "Emails",
    remove: "Remove",

    upload: "Upload",
    draw: "Draw",
    input: "Input",
    chooseSignMethod: "Choose sign method",
    signatureImageDrawingTip: "Don't draw your signature over the QR code",
    signatureImageDescription1: "Please draw your signature image over the box",
    signatureImageDescription2:
        "By signing this document with an electronic signature, you agree that this signature will be as valid as a handwritten signature under local laws",
    signText: "Sign text",
    clearSignature: "Clear signature",
    signatureImage: "Signature image",
    drawSignature: "Draw signature",
    fullName: "Full name",
    uploadSignature: "Upload signature",
    deleteSignature: "Delete signature",
    localCertification: "Local certificate",
    usbToken: "USB token",
    usbTokenDescription1: "Use one advanced signing token per USB port",
    usbTokenDescription2: "To do so, you have to download the plugin by clicking the download button",
    usbTokenDescription3: "Note: Only supported on Windows 10 operating system",
    geoLocation: "Geo Location",
    geolocationDescription:
        "<span>Geolocation is used to comply with legal and regulatory requirements. In certain cases, regulations or laws may require the collection of location information. For example, in the case of financial services, it may be necessary to collect geolocation information to comply with anti-money laundering regulations or to prevent fraud. Verifying the geographic location helps ensure that transactions or events take place within the boundaries of the same country or state, as required by relevant regulations.</span><br><br><span>Note: The database used for IP geolocation may contain errors or be outdated. This can result in incorrect information or incorrect locations associated with a particular IP address.</span>",
    useGeoLocation: "Activate geolocation",
    geolocationCheckboxDescription:
        "I accept the <a href='https://legale.io/docs/use-and-processing-of-geolocation-data-in-legale-io/' target='_blank'>privacy policy</a> and authorize the use of my location to determine the corresponding notarial jurisdiction.",
    noNumberToUseGeolocation:
        "You have no amount to use Geolocation, please buy it in store first or contact with your executive.",
    SUCCESS_DOCUMENTS_SIGNED: "Successfully signed selected documents.",
    FAIL_DOCUMENTS_SIGNED: "Failed to sign selected documents.",
    SUCCESS_BULK_SIGN: "Successfully signed all selected {{successCount}} documents.",
    INFO_BULK_SIGN: "Successfully signed {{successCount}} of selected {{totalCount}} documents.",
    ERROR_BULK_SIGN: "Failed to sign selected documents.",
    geolocationNotAuthorized: "Geolocation is required, you need to authorize the use of location.",
    SIGN_METHODS_INVALID: "You can not sign multiple documents using advanced signature. Please select a single document and try again.",
    SUCCESS_SIGN_TRIGGER: "Successfully started signing thread.",
    WARNING_FEA_BULK_SIGN: "You can not sign multiple documents by advanced signatures.",

    // DOCUMENT
    documentPreview: "Document preview",
    pdfPaginationDescription: "Page {{pageNumber}} of {{totalPage}}",

    // TICKET
    request: "Request",
    tickets: "Tickets",
    myTickets: "My tickets",
    createTicket: "Create ticket",
    subject: "Subject",
    create: "Create",
    ticket: "Ticket",
    chat: "Chat",
    viewHistory: "View history",
    open: "Open",
    inProgress: "In progress",
    resolved: "Resolved",
    closed: "Closed",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    status: "Status",
    priority: "Priority",
    edit: "Edit",
    closeTicket: "Close ticket",
    resolveTicket: "Resolve ticket",
    cancel: "Cancel",
    save: "Save",
    resolve: "Resolve",
    close: "Close",
    noTicketCreated: "No ticket created",
    selectFileDescription:
        '<span>You can drag files like {{fileTypes}} to upload to legale <br> or <span class="color-blue">click to select them</span></span>',
    category: "Category",
    subCategory: "Subcategory",
    editTemplate: "Edit template",
    templateContent: "Template content",
    name: "Name",
    callbackUrl: "Callback URL",
    content: "Content",
    formFields: "Form fields",
    noFormFields: "No form fields",
    unnamedField: "Unnamed field",
    portrait: "Portrait",
    landscape: "Landscape",
    preview: "Preview",
    smartTemplateSaved: "Smart template saved successfully",
    unsavedChangesTitle: "You have unsaved changes",
    unsavedChangesDescription:
        "If you leave this page now, your changes will be lost.\nDo you want to save your document before leaving?",
    discardChanges: "Discard changes",
    stayOnPage: "Stay on page",
    saveAndLeave: "Save and leave",
    ERROR_SMART_TEMPLATE_FIELDS_REQUIRED: "Please complete all required fields",
    home: "Home",
    versionControl: "Version control",
    previewForm: "Preview form",
    importFromDocx: "Import from DOCX",
    ai: "AI",
    addField: "Add field",
    copyFieldNumber: "Copy field number",
    copyIntoYourTemplate: "Copy into your template",
    fieldConfiguration: "Field configuration",
    moveFieldUp: "Move field up",
    moveFieldDown: "Move field down",
    addFile: "Add file",
    fileConfiguration: "File configuration",
    moveFileUp: "Move file up",
    moveFileDown: "Move file down",
    attachedFiles: "Attached files",
    watermark: "Watermark",
    opacity: "Opacity",
    rotation: "Rotation",
    noAttachedFiles: "No attached files",
    previewFormHelp: "This is a preview of the form fields.",
    type: "Type",
    hidden: "Hidden",
    text: "Text",
    fieldType_select: "Select",
    number: "Number",
    time: "Time",
    paragraph: "Paragraph",
    phone: "Phone",
    link: "Link",
    image: "Image",
    title: "Title",
    imagePreview: "Image preview",
    fileLengthError: "Maximum length is {{limit}} characters",
    yesNo: "Yes/No",
    currentDate: "Current date",
    conditionalWord: "Conditional word",
    conditionalParagraph: "Conditional paragraph",
    multipleConditionalParagraph: "Multiple conditional paragraph",
    takePhoto: "Take photo",
    conditionalImage: "Conditional image",
    answerSelection: "Answer selection",
    answerSummary: "Answer summary",
    GUID: "GUID",
    userName: "User name",
    origin: "Origin",
    idNumber: "ID number",
    Folio: "Folio",
    documentCompliance: "Document compliance",
    itemGroup: "Item group",
    isMultipleSelection: "Multiple selection",
    conditionalVisible: "Conditionally visible",
    noFormat: "No format",
    numberInWords: "number in words",
    NumberInWords: "Number in words",
    attachedToDocument: "Attached to document",
    createNewFile: "Create new file",
    warningSelectWithoutItem: "Add at least one selectable item",
    inputSelectableItem: "Selectable item",
    add: "Add",
    groups: "Groups",
    groupName: "Group name",
    documentType: "Document type",
    warningWithoutDocumentTypes: "Add at least one document type",
    warningWithoutGroups: "Add at least one group",
    history: "History",
    comments: "Comments",
    draft: "Draft",
    restoreThisVersion: "Restore this version",
    noComments: "No comments",
    addComment: "Add comment",
    selectTextToComment: "Select text in the editor, then add a comment",
    SUCCESS_VERSION_RESTORED: "Version restored successfully",
    edited: "edited",
    reply: "Reply",
    justNow: "just now",
    minAgo: "{{count}} min ago",
    minsAgo: "{{count}} mins ago",
    hourAgo: "{{count}} hour ago",
    hoursAgo: "{{count}} hours ago",
    dayAgo: "{{count}} day ago",
    daysAgo: "{{count}} days ago",
    CONFIRM_DELETE: "Are you sure to delete?",
    review: "Review",
    delete: "Delete",
    lastUpdate: "Last update",
    no: "No",
    ticketDetail: "Ticket detail",
    backToTickets: "Back to tickets",
    userInformation: "User information",
    contactInformation: "Contact information",
    noMessages: "No messages yet. Start the conversation!",
    ok: "OK",
    firstName: "First name",
    lastName1: "Last name 1",
    lastName2: "Last name 2",
    typeMessage: "Type a message...",

    // MISC
    insert: "Insert",
    format: "Format",
    note: "Note",
    selectFile: "Select file",
    selectUser: "Select user",

    // SMART TEMPLATE REVIEWS
    reviews: "Reviews",
    accept: "Accept",
    reject: "Reject",
    feedback: "Feedback",
    revert: "Revert",
    acceptAll: "Accept all",
    rejectAll: "Reject all",
    complete: "Complete",
    noSuggestions: "No suggestions",
    addFeedback: "Add feedback",
    addedParagraph: "Added paragraph",
    removedParagraph: "Removed paragraph",
    modifiedText: "Modified text",
    replacedTextWithText: "Replaced text with text",
};
